import React from 'react';
import './StatsSection.css'; // नीचे दिया गया CSS यहाँ इम्पोर्ट करें

const statsData = [
  { count: "200+", label: "Completed Projects", icon: "fa-briefcase" },
  { count: "150+", label: "Satisfied Clients", icon: "fa-heart" },
  { count: "25+", label: "Professional Experts", icon: "fa-users" },
  { count: "50+", label: "Places Service", icon: "fa-map-marker-alt" }
];

const StatsSection = () => {
  return (
    <section className="stats-section py-5">
      <div className="container">
        <div className="row g-4">
          {statsData.map((item, index) => (
            <div className="col-md-3 col-6" key={index}>
              <div className="stats-card text-center p-4">
                <i className={`fas ${item.icon} fa-2x mb-3 text-primary`}></i>
                <h2 className="display-6 fw-bold">{item.count}</h2>
                <p className="text-muted mb-0">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;